import { Subscription } from "rxjs";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';

import swal from "bootstrap-sweetalert";

import { ProfileService } from "app/services/profile.service";
import { NewPasswordComponent, PasswordChangeData } from "../asset/newPassword/newPassword-form.component";

@Component({
  templateUrl: "resetPassword.component.html",
  styleUrls: ["resetPassword.component.scss"]
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild('newPassword') newPasswordComponent:NewPasswordComponent;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _profileService: ProfileService,
    private _router: Router) { }

  ngOnInit() {
    this._activatedRoute
      .queryParams
      .subscribe(params => {
        this.token = params['token'];
      });
  }

  private _resetPasswordSubscription: Subscription = null;
  resetPassword(data : PasswordChangeData) {
    this._resetPasswordSubscription = this._profileService.resetPassword(data.newPassword, this.token)
      .subscribe(_ => {
        swal('Ок', 'Восставление учётной записи успешно выполнена', 'success');
        this._router.navigate(['/call/list']);
      },
      error => {
        switch (error as ProfileService.ActivateTokenError) {
          case "TemporaryTokenDateIsExpired":
            this._resetPasswordError = 'Срок действия токена истёк';
            break;
          default:
            this._resetPasswordError = 'При восстановлении произошла ошибка. Токен является недействительным';
        }
      },
      () => {
        this.newPasswordComponent.clearFileds();
      });
  }

  private _resetPasswordError: string = null;

  token: string;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/account/resetPassword/resetPassword.component.ts